import { CartProductCode, PriceCartItem } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { getPromotionTitle } from '../../../../utils/stringHelper';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';
import { isFullDiscount } from '../../../../utils/numberHelper';

export const PromotionsPriceCartItem = () => {
  const [priceCart] = useGlobalState('priceCart');
  const [memberDetails] = useGlobalState('memberDetails');
  const { inRenewal } = memberDetails;
  const { items } = priceCart;

  let itemsWithDiscount: PriceCartItem[] = [];
  if (items) {
    itemsWithDiscount = items.filter((item) => item.discount !== undefined && item.discount > 0);
  }

  type discountListItem = {
    name: string;
    amount: number;
  };

  const discountList: discountListItem[] = [];
  const freeAssociateList: PriceCartItem[] = [];
  const associateDiscountList: PriceCartItem[] = [];

  itemsWithDiscount.forEach((item) => {
    //list of free associate discounts
    if (item.code === CartProductCode.ASSOCIATE) {
      if (isFullDiscount(item.price, item.discount!)) {
        freeAssociateList.push(item);
      } else {
        //list of discounted associates
        associateDiscountList.push(item);
      }
    } else {
      const result: discountListItem = {
        name: getPromotionTitle(item.code, inRenewal, isFullDiscount(item.price, item.discount!)),
        amount: item.discount!,
      };
      discountList.push(result);
    }
  });

  const numOfFreeAssociate = freeAssociateList.length;

  if (numOfFreeAssociate !== 0) {
    discountList.push({
      name: `${numOfFreeAssociate} free family member${numOfFreeAssociate > 1 ? 's' : ''}`,
      amount: freeAssociateList.reduce((sum, item) => sum + item.discount!, 0),
    });
  }

  if (associateDiscountList.length !== 0) {
    discountList.push({
      name: 'Family member discount',
      amount: associateDiscountList.reduce((sum, item) => sum + item.discount!, 0),
    });
  }

  return itemsWithDiscount.length !== 0 ? (
    <ManageMembershipPriceCartItem
      type="description"
      subtitle="Promotions"
      className="promotions-price-item"
      promoList={discountList}
    />
  ) : (
    <></>
  );
};
